import classNames from "classnames";
import { uniqueId } from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";

import css from "./checkbox.module.scss";

const Checkbox = ({
  className,
  label,
  checked,
  small,
  waggle,
  disabled,
  style,
  handleChange,
  id,
  classes
}) => {
  const [checkboxId] = useState(() => id || uniqueId("checkbox"));

  return (
    <label
      className={classNames(css.component, className, { [css.small]: small })}
      style={style}
      htmlFor={checkboxId}
    >
      <div className={css.wrap}>
        <input
          className={css.input}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(ev) => handleChange(ev.target.checked, ev)}
          id={checkboxId}
        />
        <div className={classNames(css.inputFake, { [css.waggleAnimation]: waggle }, classes?.inputFake)} />
        <span className={classNames(css.label, { [css.disabled]: disabled })}> {label} </span>
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  waggle: PropTypes.bool,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  id: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    inputFake: PropTypes.string
  })
};

Checkbox.defaultProps = {
  label: "",
  waggle: false,
  small: true,
  disabled: false,
  style: null
};

export default Checkbox;
